import React from "react";
import { Link } from "@tiny/components";
import { useTinyImporterSample } from "./TinyImporterSample.hooks";

function TinyImporterSample() {
  const { download } = useTinyImporterSample();
  return <Link onClick={download}>Download your sample csv file here</Link>;
}

export default TinyImporterSample;
